import React from "react";
import { Link } from "react-router-dom";

export default function Questions() {
  return (
    <>
      <section className="beart-section">
        <div className="flex flex-row">
          <div className="my-5 hidden p-4 md:block">
            <i className="bi bi-chat text-5xl"></i>
          </div>
          <div className="flex-1">
            <h2 className="beart-title">Miért művészetterápia?</h2>
            <div className="mb-2">
              A művészetterápiás alkotásokban megjelenhetnek nemcsak a tudatos,
              hanem a tudattalan belső tartalmaink, a sokszor fel nem ismert
              gondolataink, érzéseink is a papírlapon, amiket kívülről szemlélve
              felismerhetőek és kimondhatókká válnak. Ez nemcsak az önkifejezést
              segíti és a kommunikációt fejleszti, hanem remek önismereti eszköz
              is.
              <div className="mt-8">
                <div className="right-0 ml-20 w-3/4">
                  <div className="mb-4">
                    <em>Németh László</em> művészetterapeuta megfogalmazásában:
                  </div>
                  <blockquote>
                    „A művészetterápia kreatív folyamat, a saját életünk
                    alkotása is egyben, a művészi alkotásokon keresztül saját
                    magunkon is dolgozunk."
                  </blockquote>
                </div>
              </div>
              <Link to="/kapcsolat" className="w-full">
                <div className="mt-8 rounded-3xl bg-green-700 bg-opacity-25 p-4 text-black transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
                  <div className="mx-auto flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
                    <div>Jelentkezés művészetterápiás foglalkozásra</div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div id="coaching" className="border-1 mt-8 block gap-4 md:flex">
          <div className="m-4 flex-1 rounded-xl border-0 border-green-700 border-opacity-25 p-4 md:border-4 md:shadow-xl">
            <div className="mx-auto hidden h-[80px] w-[80px] content-center justify-center justify-items-center rounded-full border-4 bg-green-700 text-center align-middle shadow-md md:flex">
              <i className="bi bi-question-circle my-4 h-[80px] w-[80px] text-4xl text-white"></i>
            </div>
            <div className="mt-4 font-bold md:text-center md:text-sm md:font-normal">
              Egyéni coaching alkalmak
            </div>
            <div className="beart-title">Mi a coaching?</div>
            <div className="mb-2 min-h-fit">
              A coaching, egy segítő beszélgetés, a Rogersi elveket tanultam és
              ezt is alkalmazom, az aktív hallgatás, a figyelem, az empátia, a
              visszajelzések és tükrözések módszereit használva a beszélgetés
              során.
            </div>
            <div className="beart-title"> Mi nem a coaching?</div>
            <div className="mb-2">
              A coaching nem tanácsadás, nem terápia, nem baráti beszélgetés,
              hanem módszertanilag vezetett segítő beszélgetés, ahol a
              kérdéseimmel vezetlek és a te aktív részvételed is szükséges a
              folyamatban.
            </div>
            <Link to="/kapcsolat" className="w-full">
              <div className="mt-8 rounded-3xl bg-green-700 bg-opacity-25 p-4 text-black transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
                <div className="mx-auto flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
                  <div>Jelentkezés</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="m-4 flex-1 rounded-xl border-0 border-purple-700 border-opacity-25 p-4 md:border-4 md:shadow-xl">
            <div className="mx-auto hidden h-[80px] w-[80px] content-center justify-center justify-items-center rounded-full border-4 bg-purple-700 text-center align-middle shadow-md md:flex">
              <i className="bi bi-droplet my-4 h-[80px] w-[80px] text-4xl text-white"></i>
            </div>
            <div className="mt-4 font-bold md:text-center md:text-sm md:font-normal">
              Mentálhigiénés szolgáltatás
            </div>
            <div id="art-coaching" className="beart-title text-nowrap">
              Mi a mentálhigiéné?
            </div>
            <div className="mb-2">
              A mentálhigiéné célja a lelki egészség védelme, megőrzése és
              fejlesztése. Nagy hangsúlya van a megelőzésnek, a prevenciónak.
              Segít a stresszkezelésben, problémamegoldásban, konfliktusok
              kezelésében, testi-lelki egyensúly megtartásában, a kiégés
              megelőzésben, illetve informatív, pszichoedukatív funkciója is
              van.
            </div>

            <Link to="/kapcsolat">
              <div className="mt-8 rounded-3xl bg-purple-700 bg-opacity-25 p-4 text-black transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
                <div className="mx-auto flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
                  <div>Jelentkezés</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="m-4 flex-1 rounded-xl border-0 border-blue-700 border-opacity-25 p-4 md:border-4 md:shadow-xl">
            <div className="mx-auto hidden h-[80px] w-[80px] content-center justify-center justify-items-center rounded-full border-4 bg-blue-500 text-center align-middle shadow-md md:flex">
              <i className="bi bi-palette my-4 h-[80px] w-[80px] text-4xl text-white"></i>
            </div>
            <div className="mt-4 font-bold md:text-center md:text-sm md:font-normal">
              Art coaching alkalmak
            </div>
            <div id="art-coaching" className="beart-title">
              Mi az Art coaching?
            </div>
            <div className="mb-2">
              Az Art coaching, pozitív művészetterápiás eszközöket használ,
              amely által új ötleteket kaphatsz egy-egy élethelyzetre. <br />A
              jelenlegi helyzetek feltárásának eszköze, megoldások keresésében,
              a problémák átkeretezésében nyújt új rálátásokat.
              <br />
              <br />
              <div className="text-center text-sm italic">
                Semmilyen előzetes rajztudás vagy készség nem szükséges az
                alkalmakhoz.
              </div>
            </div>
            <Link to="/kapcsolat" className="bottom-0">
              <div className="mt-8 rounded-3xl bg-blue-700 bg-opacity-25 p-4 text-black transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
                <div className="mx-auto flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
                  <div>Jelentkezés</div>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="mt-8 rounded-3xl p-4 text-orange-700 transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
          <Link to="/kapcsolat">
            <div className="mx-ato flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
              <div className="mr-2 flex gap-2">
                <i className="bi bi-hand-index-thumb animate-pulse animate-delay-75"></i>{" "}
                <i className="bi bi-cursor animate-pulse animate-delay-300"></i>
              </div>
              <div>Bővebb információkért keress bátran!</div>
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}
